export default class Cookies {
	static get(name: string): string {
		let key = name + "=";
		let cookieList = document.cookie.split(';');
		for (let i = 0; i < cookieList.length; i++) {
			let cookie = cookieList[i].trim();
			if (cookie.indexOf(key) === 0) {
				return cookie.substring(key.length, cookie.length);
			}
		}
		return "";
	}

	static set(name: string, value: string, expirationDays: number): void {
		let d: Date = new Date();
		d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
	}
}
